import * as a from '@mitranim/js/all.mjs'
import * as uo from './util-obs.mjs'
import * as um from './util-misc.mjs'
import * as ud from './util-dom.mjs'

export function isTransformableImageSource(val) {
  return a.isFile(val) || a.isValidStr(val)
}

/*
Base "nop" implementation for use in SSR and when external integrations are
disabled.
*/
export class Filestack extends uo.IniterObs {
  async transform() {}
}

/*
This code has been placed in its own file due to cyclic initialization conflicts
between other util files.
*/
export class ClientFilestack extends Filestack {
  // Caution: this promise resolves ONLY when the user clicks the "save" button
  // in the Filestack UI for file transformation. Otherwise this promise hangs
  // forever. This is also a minor memory leak.
  async transform(src) {
    if (!a.opt(src, isTransformableImageSource)) return undefined

    await this.init()
    const tran = this.makeTran()

    try {
      return await tran.open(src)
    }
    finally {
      if (tran.app) tran.close()
    }
  }

  makeTran() {
    const tar = new window.FilestackTransform(new FilestackFakeClient())

    tar.setConfig({
      editor: {
        text: {enabled: false},
        border: {enabled: false},
        overlay: {enabled: false},
        transforms: {ratios: []},
      },
      output: {blob: true},
    })

    return tar
  }

  // Invoked by `.init`. See superclasses.
  async initAsync() {
    await um.plist()
      .add(ud.mountStyle(`0bfb527f888a4f739f54f8531cdda944`, `https://static.filestackapi.com/transforms-ui/2.x.x/transforms.css`))
      .add(ud.mountScript(`ae0708452bf3497aae69f61d0a3c7314`, `https://static.filestackapi.com/transforms-ui/2.x.x/transforms.umd.min.js`))
  }
}

class FilestackFakeClient extends a.Emp {
  async prefetch() {
    return {
      blocked: false,
      permissions: {transforms_ui: true},
      settings: {inapp_browser: false},
    }
  }
}
